export default {
  TITLE: `Project`,
  LIST: {
    TITLE: `Project list`,
    SUMMARY: ``
  },
  CREATE_HEADER: {
    TITLE: `Create a project`,
    SUMMARY: ``
  },
  EDIT: {
    TITLE: `Edit the project`,
    SUMMARY: ``
  },
  VIEW: {
    TITLE: `View the project`,
    SUMMARY: ``
  },
  CREATE: `Create a project`,
  VIEW_PROJECT_TEMPLATES: `View templates for project`,
  DELETE_BUTTON: {
    TITLE: `Delete this project`,
    SUMMARY: `Are you sure you want to delete this project?`,
    PRIMARY_ACTION: `Delete`
  },
  CODE: `Code`,
  STATUS: `Status`,
  STATUSES: {
    CONFIRMED: `Confirmed`,
    TENTATIVE: `Tentative`,
    CANCELLED: `Cancelled`,
    PLACEHOLDER: `Placeholder`,
    COMPLETED: `Completed`,
    ARCHIVED: `Archived`
  },
  NAME: 'Name',
  TAGS: `Tags`,
  NOTES: `Notes`,
  ADDITIONAL_INFO: `Additional info`,
  BILLING_DETAILS: `Billing`,
  CLIENTS: `Clients`,
  DEFAULT_SHIFT_LENGTH: `Default shift length`,
  DEFAULT_START_TIME: `Default shift start`,
  POSITIONS: `Positions`,
  PROJECT_OWNERS: `Project owners`,
  LOCKED_USERS: `Locked users`,
  PREFERRED_USERS: `Preferred users`,
  BLOCKED_USERS: `Blocked users`,
  ASSOCIATED_PROJECTS: `Associated projects`,
  REQUIRED_ATTRIBUTES: `Required attributes`,
  PREFERRED_ATTRIBUTES: `Preferred attributes`,
  DEFAULTSHIFTTAGS: `Default shift tags`,
  CUSTOM_FIELD_1: `Custom field 1`,
  csv: {
    NAME: `Project Name`,
    CODE: `Project Code`,
    STATUS: `Status`,
    DEFAULTSHIFTTAGS: `Default shift tags`,
    TAGS: `Tags`,
    CLIENTS: `Clients`,
    ASSOCIATEDPROJECTS: `Associated projects`,
    ADDITIONALINFO: `Additional info`,
    NOTES: `Notes`,
    REQUIREDATTRIBUTES: `Required attributes`,
    PREFERREDATTRIBUTES: `Preferred attributes`,
    CSV_NAME: `project_list_export_{{ date }}`,
    START: `Start`,
    END: `End`
  },
  form: {
    ERRORS: {
      NAME_REQUIRED: `Project name is required`,
      CODE_REQUIRED: `Project code is required`
    },
    EDIT: {
      TITLE: `Edit a project`,
      SUMMARY: ``
    },
    CREATE: {
      TITLE: `Create a project`,
      SUMMARY: ``
    },
    USER_RESTRICTIONS: `User restrictions`,
    PROJECT_ATTRIBUTES: `Project attributes`,
    NAME: {
      LABEL: `Name`,
      PLACEHOLDER: `Enter a name for the project`,
      DESCRIPTION: `Used to identify the project.`
    },
    CODE: {
      LABEL: `Code`,
      PLACEHOLDER: `Enter a short code for the project`,
      DESCRIPTION: `Used to quickly identify which project a shift belongs to in the schedule.`
    },
    CLIENTS: {
      LABEL: `Clients`,
      PLACEHOLDER: `Select a client or clients`,
      DESCRIPTION: `Used to associate a project with one or more clients.`
    },
    CUSTOMFIELD1: {
      LABEL: `Custom field 1`,
      PLACEHOLDER: `Enter a value for the custom field`,
      DESCRIPTION: `Used during integrations to associate with remote resources.`
    },
    DEFAULTSHIFTLENGTH: {
      LABEL: `Default shift length`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Used to pre-fill shift length when creating a template for this project.`
    },
    DEFAULTSTARTTIME: {
      LABEL: `Default start time`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Used to pre-fill shift start time when creating a template for this project.`
    },
    POSITIONS: {
      LABEL: `Positions`,
      PLACEHOLDER: `Add some positions to this project`,
      DESCRIPTION: `Used to limit which positions can be used in the templates for this project.`
    },
    PROJECTOWNERS: {
      LABEL: `Project owners`,
      PLACEHOLDER: `Select project owners`,
      DESCRIPTION: `Used to associate this project with one or more users, this can be used for filtering and notification emails.`
    },
    STATUS: {
      LABEL: `Status`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Used to indicate the current project status.`
    },
    TAGS: {
      LABEL: `Tags`,
      PLACEHOLDER: `Enter one or more tags`,
      DESCRIPTION: `Used as a free-form field for custom tags when filtering.`
    },
    DEFAULTSHIFTTAGS: {
      LABEL: `Default shift tags`,
      PLACEHOLDER: `Enter one or more tags`,
      DESCRIPTION: `Used to load default tags when a shift is assigned to this project. Existing shifts will not be modified if these tags change.`
    },
    ADDITIONALINFO: {
      LABEL: `Additional info`,
      PLACEHOLDER: `Add some more information to this project`,
      DESCRIPTION: `The content of this field is transmitted to employees when sending shift notifications for the project. This field supports translations using #en and #fr.`
    },
    NOTES: {
      LABEL: `Notes`,
      PLACEHOLDER: `Add some notes to the project`,
      DESCRIPTION: `The content of this field is not transmitted and is solely for reference when viewing the project.`
    },
    LOCKEDUSERS: {
      LABEL: `Locked users`,
      PLACEHOLDER: `Add some locked users`,
      DESCRIPTION: `Used to flag users that should not be assigned on other projects.`
    },
    PREFERREDUSERS: {
      LABEL: `Preferred users`,
      PLACEHOLDER: `Add some preferred users`,
      DESCRIPTION: `Used to indicate that a user is preferred on a project when assigning them to a shift on the schedule, does not prevent assigning the user to another project.`
    },
    BLOCKEDUSERS: {
      LABEL: `Blocked users`,
      PLACEHOLDER: `Add some blocked users`,
      DESCRIPTION: `Used to flag users that should not be assigned to this project.`
    },
    ASSOCIATEDPROJECTS: {
      LABEL: `Associated projects`,
      PLACEHOLDER: `Associate projects with this project`,
      DESCRIPTION: `Used when calculating project experience, will indicate cumulative experience from associated projects.`
    },
    REQUIREDATTRIBUTES: {
      TITLE: `Required attributes`,
      DESCRIPTION: `Used to flag users that do not have the required attributes to be assigned to this project.`
    },
    PREFERREDATTRIBUTES: {
      TITLE: `Preferred attributes`,
      DESCRIPTION: `Used to sort users when assigning to this project.`
    },
    ALREADY_IN_USE: {
      PROJECT_CODE: `Project code is already in use.`
    },
    CREATE_CLIENT_MODAL: {
      TITLE: `Create a new client tag`,
      SUMMARY: ``
    }
  },
  IMPORT_PROJECTS: `Import projects`,
  import: {
    LINE: `Line`,
    VALIDATION: `Validation`,
    NAME: `Name`,
    NAME_DESC: `The name of the project`,
    STATUS: `Status`,
    STATUS_DESC: `Must be one of the following project statuses: <1>CONFIRMED, TENTATIVE, CANCELLED, PLACEHOLDER, COMPLETED</1>`,
    CODE: `Code`,
    CODE_DESC: `The project code must be unique`,
    START: `Start`,
    START_DESC: `Start date in <1>YYYY-MM-DD</1> format, for example January 30th 2010  would be <1>2010-01-30</1>.`,
    END: `End`,
    END_DESC: `End Date in the same format as start date.`,
    DEPARTMENTS: `Departments`,
    DEPARTMENTS_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    POSITIONS: `Positions`,
    POSITIONS_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    PROJECTOWNERS: `Project owners`,
    PROJECTOWNERS_DESC: `Must be a valid employee number. To enter more than one value leave a space between each code.`,
    TAGS: `Tags`,
    TAGS_DESC: `Freeform tags. To enter more than one value leave a space between each code`,
    DEFAULTSHIFTTAGS: `Default shift tags`,
    DEFAULTSHIFTTAGS_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    ADDITIONALINFO: `Additionnal info `,
    ADDITIONALINFO_DESC: `Freeform note field shown in notification emails`,
    NOTES: `Notes`,
    NOTES_DESC: `Freeform note field hidden from employees`,
    LOCKEDUSERS: `Locked users`,
    LOCKEDUSERS_DESC: `Must be a valid employee number. To enter more than one value leave a space between each code.`,
    PREFERREDUSERS: `Preferred users`,
    PREFERREDUSERS_DESC: `Must be a valid employee number. To enter more than one value leave a space between each code.`,
    BLOCKEDUSERS: `Blocked users`,
    BLOCKEDUSERS_DESC: `Must be a valid employee number. To enter more than one value leave a space between each code.`,
    REQUIREDATTRIBUTES: `Required attributs`,
    REQUIREDATTRIBUTES_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    PREFERREDATTRIBUTES: `Preferred attributes`,
    PREFERREDATTRIBUTES_DESC: `Must be an import code as chosen by your administrator. To enter more than one value leave a space between each code.`,
    TITLE: {
      TITLE: `Import projects`,
      SUMMARY: ``
    },
    MISSING_HEADERS: `Missing the following header: <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Missing the following headers: <0>{{value}}</0>`,
    MANDATORY_FIELDS: `Required fields instructions`,
    OPTIONAL_FIELDS: `Optional fields instructions`,
    NOT_VALID: `There was <0>{{count}}</0> invalid project.`,
    NOT_VALID_other: `There was <0>{{count}}</0> invalid projectss.`,
    SAVE_FAILED: `There was <0>{{count}}</0> project that were not saved.`,
    SAVE_FAILED_other: `There were <0>{{count}}</0> projects that were not saved.`,
    ERROR_READING_CSV: `The file that was uploaded does not respect the proper CSV format, if your excel is in french, please change your delimiter settings.`,
    TEMPLATE_FILE_NAME: `project_import_template`,
    DOWNLOAD_TEMPLATE: `Download template`
  }
}
